// АВТОГЕНЕРИРОВАННЫЙ ФАЙЛ — НЕ РЕДАКТИРУЙТЕ ВРУЧНУЮ.
// Источник правды: data-source/korpy_balance_v6.xlsx
// Регенерация: npm run gen-cards (или двойной клик по tools/gen-cards.bat)
// Сгенерировано: 2026-06-03T21:08:21.155Z

export const cards = [
  {
    "id": "deus_arhiv_deusa",
    "name_ru": "Архив Деуса",
    "name_en": "Deus Archive",
    "faction": "deus",
    "type": "unit",
    "rarity": "epic",
    "archetype": null,
    "exclusive_hero": "deus_sina",
    "atk": 4,
    "armor": 2,
    "hp": 4,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 4,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "При смерти союзного юнита получает +1/0/0, а случайный союзный юнит получает +1/0/0. В  конце каждого хода призывает Стажёра"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "ally_died",
      "filter": "any",
      "target": "composite",
      "effect": "composite",
      "value": "buff_self_perm:1/0/0@self|buff_perm:1/0/0@ally_random",
      "duration": "permanent"
    },
    "dsl_trigger2": {
      "event": "turn_end",
      "filter": "any",
      "target": "self",
      "effect": "summon",
      "value": "deus_stazher",
      "duration": "oneshot"
    },
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Хранит всё. Имена. Подписи. Голоса. Лица. Даже того, кого больше нет.",
    "ability_text_en": {
      "trigger": "When an allied unit dies, gets +1/0/0, and a random allied unit gets +1/0/0. At the end of each turn, summons an Intern"
    }
  },
  {
    "id": "deus_bezymyany_ispolnitel",
    "name_ru": "Безымянный исполнитель",
    "name_en": "Nameless Executor",
    "faction": "deus",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "deus_sina",
    "atk": 1,
    "armor": 1,
    "hp": 3,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "При смерти союзного юнита получает +1/0/0"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "ally_died",
      "filter": "any",
      "target": "self",
      "effect": "buff_self_perm",
      "value": "1/0/0",
      "duration": "permanent"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "У него есть номер. Не имя. Имена дают тем, кого ждут.",
    "ability_text_en": {
      "trigger": "When an allied unit dies, gets +1/0/0"
    }
  },
  {
    "id": "deus_boevoe_snaryazhenie",
    "name_ru": "Боевое снаряжение",
    "name_en": "Combat Gear",
    "faction": "deus",
    "type": "action",
    "rarity": "epic",
    "archetype": null,
    "exclusive_hero": "deus_nikosi",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 4,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Герой получает +2 атаки и Пробитие"
    },
    "dsl_order": {
      "target": "composite",
      "effect": "composite",
      "value": "buff_stats:2/0/0@hero_self|give_keyword:pierce@hero_self",
      "duration": "permanent"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Раз и навсегда. Никаких возвратов.",
    "ability_text_en": {
      "order": "The Hero gets +2 attack and Pierce"
    }
  },
  {
    "id": "deus_boevoy_implant",
    "name_ru": "Боевой имплант",
    "name_en": "Combat Implant",
    "faction": "deus",
    "type": "action",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "deus_nikosi",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Герой получает Неистовство до конца следующего хода"
    },
    "dsl_order": {
      "target": "hero_self",
      "effect": "give_keyword",
      "keyword": "frenzy",
      "duration": "until_end_of_next_turn"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Имплант устанавливают за 4 часа. Снимают за 4 минуты — после смерти.",
    "ability_text_en": {
      "order": "The Hero gains Frenzy until the end of the next turn"
    }
  },
  {
    "id": "deus_buhgalter",
    "name_ru": "Бухгалтер Влияния",
    "name_en": "Influence Accountant",
    "faction": "deus",
    "type": "unit",
    "rarity": "common",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 1,
    "armor": 0,
    "hp": 2,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 1,
    "deck_limit": 3,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "+1 Влияния"
    },
    "dsl_order": {
      "target": "self",
      "effect": "influence_gain",
      "value": "1",
      "duration": "oneshot"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Считает не деньги, а голоса акционеров. Карандаш и ноутбук — два главных оружия.",
    "ability_text_en": {
      "order": "+1 Influence"
    }
  },
  {
    "id": "deus_bunker_kirosy",
    "name_ru": "Бункер Киросы",
    "name_en": "Kirosa's Bunker",
    "faction": "deus",
    "type": "unit",
    "rarity": "epic",
    "archetype": null,
    "exclusive_hero": "deus_kirosa",
    "atk": 0,
    "armor": 3,
    "hp": 8,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 4,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "aura": "Пока этот юнит жив, Герой получает +2 max ХП",
      "trigger": "В начале каждого хода Герой восстанавливает 1 ХП"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "turn_start",
      "filter": "any",
      "target": "hero_self",
      "effect": "heal",
      "value": "1",
      "duration": "oneshot"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": {
      "filter": "while_alive",
      "target": "hero_self",
      "effect": "increase_max_hp",
      "value": "2"
    },
    "flavor_ru": "Не офис. Не дом. Третье место — где она работает, ест и убивает несогласных.",
    "ability_text_en": {
      "aura": "While this unit is alive, the Hero gets +2 max hp",
      "trigger": "At the start of each turn, the Hero restores 1 hp"
    }
  },
  {
    "id": "deus_dvoynik_nikosi",
    "name_ru": "Двойник Никоси",
    "name_en": "Nikosi Double",
    "faction": "deus",
    "type": "unit",
    "rarity": "epic",
    "archetype": null,
    "exclusive_hero": "deus_nikosi",
    "atk": 4,
    "armor": 0,
    "hp": 4,
    "keywords": [
      "stealth"
    ],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 4,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "Когда этот юнит атакует, Герой получает 1 дополнительную атаку в этом же ходу"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "unit_attack",
      "filter": "self",
      "target": "hero_self",
      "effect": "extra_attack",
      "value": "1",
      "duration": "oneshot"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Их сделали в одной партии. На случай если оригинал... перестанет быть оригиналом.",
    "ability_text_en": {
      "trigger": "When this unit attacks, the Hero gets 1 extra attack this turn"
    }
  },
  {
    "id": "deus_dvoynoy_agent",
    "name_ru": "Двойной агент",
    "name_en": "Double Agent",
    "faction": "deus",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "deus_kirosa",
    "atk": 2,
    "armor": 1,
    "hp": 3,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "перемани вражеского юнита с атакой = 1 на свою сторону"
    },
    "dsl_order": {
      "target": "enemy_choose",
      "effect": "mind_control",
      "duration": "permanent",
      "condition": "target_atk_eq_1"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Работал на нас. Потом на них. Теперь обратно — но кто знает?",
    "ability_text_en": {
      "order": "Take control of an enemy unit with attack = 1"
    }
  },
  {
    "id": "deus_fin_razvedchik",
    "name_ru": "Финансовый разведчик",
    "name_en": "Financial Scout",
    "faction": "deus",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "deus_tanaki",
    "atk": 1,
    "armor": 0,
    "hp": 3,
    "keywords": [
      "stealth"
    ],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "При появлении союзного юнита на поле даёт +1 Влияния"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "ally_summoned",
      "filter": "any",
      "target": "self",
      "effect": "influence_gain",
      "value": "1",
      "duration": "oneshot"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Знает где деньги — но не там где они должны быть.",
    "ability_text_en": {
      "trigger": "When an allied unit enters the field, gives +1 Influence"
    }
  },
  {
    "id": "deus_finansovy_analitik",
    "name_ru": "Финансовый аналитик",
    "name_en": "Financial Analyst",
    "faction": "deus",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 1,
    "armor": 1,
    "hp": 4,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "deathrattle": "+2 Влияния и добор 1 карты"
    },
    "dsl_order": null,
    "dsl_deathrattle": {
      "target": "composite",
      "effect": "composite",
      "value": "influence_gain:2@self|draw:1@self",
      "duration": "oneshot"
    },
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Знает где спрятаны корпоративные деньги. И где спрятаны те, кто это знал до него.",
    "ability_text_en": {
      "deathrattle": "+2 Influence and draw 1 card"
    }
  },
  {
    "id": "deus_implanty_khishchnik",
    "name_ru": "Импланты «Хищник»",
    "name_en": "Predator Implants",
    "faction": "deus",
    "type": "action",
    "rarity": "legendary",
    "archetype": null,
    "exclusive_hero": "deus_nikosi",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 5,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Герой получает +3 атаки, Пробитие и Неистовство"
    },
    "dsl_order": {
      "target": "composite",
      "effect": "composite",
      "value": "buff_stats:3/0/0@hero_self|give_keyword:pierce@hero_self|give_keyword:frenzy@hero_self",
      "duration": "permanent"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Это уже не апгрейд. Это новая модель.",
    "ability_text_en": {
      "order": "The Hero gets +3 attack, Pierce and Frenzy"
    }
  },
  {
    "id": "deus_inf_dvoynik_kirosy",
    "name_ru": "Двойник Киросы",
    "name_en": "Kirosa's Double",
    "faction": "deus",
    "type": "influence",
    "rarity": "special",
    "archetype": null,
    "exclusive_hero": "deus_kirosa",
    "atk": 0,
    "armor": 3,
    "hp": 8,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": 9,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "aura": "Пока этот юнит жив, Герой получает Иммунитет (восстанавливается в начале каждого хода)"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": {
      "filter": "while_alive",
      "target": "hero_self",
      "effect": "give_keyword",
      "keyword": "immune"
    },
    "flavor_ru": "Знаешь почему Кироса не выходит в свет? Потому что выходит он. И возвращается тоже он.",
    "ability_text_en": {
      "aura": "While this unit is alive, the Hero gains Immune (refreshed at the start of each turn)"
    }
  },
  {
    "id": "deus_inf_elite_strelok",
    "name_ru": "Элитный стрелок",
    "name_en": "Elite Marksman",
    "faction": "deus",
    "type": "influence",
    "rarity": "special",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 4,
    "armor": 0,
    "hp": 3,
    "keywords": [
      "pierce"
    ],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": 4,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {},
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Целью становится тот, у кого толстая броня. Так чаще."
  },
  {
    "id": "deus_inf_kladbishche_kontraktov",
    "name_ru": "Кладбище контрактов",
    "name_en": "Contract Cemetery",
    "faction": "deus",
    "type": "influence",
    "rarity": "special",
    "archetype": null,
    "exclusive_hero": "deus_sina",
    "atk": 1,
    "armor": 2,
    "hp": 6,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": 6,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "Когда умирает любой союзник, добери 1 карту"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "ally_died",
      "filter": "any",
      "target": "self",
      "effect": "draw",
      "value": "1",
      "duration": "oneshot"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Тысячи папок с подписями. Тысячи имён. Тысячи фотографий с пустыми глазами. Сюда не приходят живые.",
    "ability_text_en": {
      "trigger": "When any ally dies, draw 1 card"
    }
  },
  {
    "id": "deus_inf_korpgvardiya",
    "name_ru": "Корпоративная гвардия",
    "name_en": "Corporate Guard",
    "faction": "deus",
    "type": "influence",
    "rarity": "special",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 3,
    "armor": 2,
    "hp": 4,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": 3,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {},
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "У них одинаковые лица, одинаковая броня, одинаковая зарплата. Различает их только число погибших на счету."
  },
  {
    "id": "deus_inf_korpshpion",
    "name_ru": "Корпшпион",
    "name_en": "Corp Spy",
    "faction": "deus",
    "type": "influence",
    "rarity": "special",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 3,
    "armor": 0,
    "hp": 3,
    "keywords": [
      "stealth"
    ],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": 3,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {},
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Никто не знает откуда он. Никто не помнит когда он пришёл. И его это устраивает."
  },
  {
    "id": "deus_inf_kurator_operatsiy",
    "name_ru": "Куратор операций",
    "name_en": "Operations Curator",
    "faction": "deus",
    "type": "influence",
    "rarity": "special",
    "archetype": null,
    "exclusive_hero": "deus_kirosa",
    "atk": 0,
    "armor": 1,
    "hp": 4,
    "keywords": [
      "stealth"
    ],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": 5,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "Когда умирает вражеский юнит, перемани случайного вражеского юнита с атакой ≤ 2 на свою сторону"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "enemy_died",
      "filter": "any",
      "target": "enemy_random",
      "effect": "mind_control",
      "duration": "permanent",
      "condition": "target_atk_le_2"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Никогда не появляется на совещаниях. Только записи решений приходят на стол Киросы.",
    "ability_text_en": {
      "trigger": "When an enemy unit dies, take control of a random enemy unit with attack ≤2"
    }
  },
  {
    "id": "deus_inf_lichny_palach",
    "name_ru": "Личный палач",
    "name_en": "Personal Executioner",
    "faction": "deus",
    "type": "influence",
    "rarity": "special",
    "archetype": null,
    "exclusive_hero": "deus_nikosi",
    "atk": 5,
    "armor": 1,
    "hp": 5,
    "keywords": [
      "stealth"
    ],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": 6,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "Когда этот юнит атакует, наноси 2 урона Герою врага"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "unit_attack",
      "filter": "self",
      "target": "hero_enemy",
      "effect": "damage",
      "value": "2",
      "duration": "oneshot"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Лицо забывают сразу. Запоминают только звук — и то ненадолго.",
    "ability_text_en": {
      "trigger": "When this unit attacks, deal 2 damage to the enemy Hero"
    }
  },
  {
    "id": "deus_inf_lichny_sovetnik",
    "name_ru": "Личный советник",
    "name_en": "Personal Advisor",
    "faction": "deus",
    "type": "influence",
    "rarity": "special",
    "archetype": null,
    "exclusive_hero": "deus_tanaki",
    "atk": 2,
    "armor": 1,
    "hp": 3,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": 2,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "При появлении на поле союзного юнита получи 1 Влияние"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "ally_summoned",
      "filter": "any",
      "target": "self",
      "effect": "influence_gain",
      "value": "1",
      "duration": "oneshot"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Знает 4 языка, 7 диалектов корпоративных переговоров и одну тайну. Самую важную.",
    "ability_text_en": {
      "trigger": "When an allied unit enters the field, gain 1 Influence"
    }
  },
  {
    "id": "deus_inf_likvidator",
    "name_ru": "Ликвидатор",
    "name_en": "Liquidator",
    "faction": "deus",
    "type": "influence",
    "rarity": "special",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 4,
    "armor": 1,
    "hp": 3,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": 4,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "нанеси 2 урона выбранному вражескому юниту"
    },
    "dsl_order": {
      "target": "enemy_choose",
      "effect": "damage",
      "value": "2",
      "duration": "oneshot"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Берёт контракты только с пожизненной гарантией. На цель.",
    "ability_text_en": {
      "order": "Deal 2 damage to a chosen enemy unit"
    }
  },
  {
    "id": "deus_inf_lyubovnitsa_tanaki",
    "name_ru": "Любовница Танаки",
    "name_en": "Tanaki's Mistress",
    "faction": "deus",
    "type": "influence",
    "rarity": "special",
    "archetype": null,
    "exclusive_hero": "deus_tanaki",
    "atk": 2,
    "armor": 3,
    "hp": 8,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": 10,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "aura": "Пока этот юнит жив, призывы из стенда Влияния стоят 0 Влияния"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": {
      "filter": "while_alive",
      "target": "self",
      "effect": "free_summons_from_stand"
    },
    "flavor_ru": "Знает каждую сделку Танаки за последние 30 лет. И ни одну из них он не подписывал без её одобрения.",
    "ability_text_en": {
      "aura": "While this unit is alive, summons from the Influence Stand cost 0 Influence"
    }
  },
  {
    "id": "deus_inf_posrednik",
    "name_ru": "Посредник",
    "name_en": "Mediator",
    "faction": "deus",
    "type": "influence",
    "rarity": "special",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 2,
    "armor": 2,
    "hp": 4,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": 4,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Герой получает +2  ХП"
    },
    "dsl_order": {
      "target": "hero_self",
      "effect": "increase_max_hp",
      "value": "2",
      "duration": "permanent"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Между корпорациями всегда есть пространство. Он живёт в этом пространстве.",
    "ability_text_en": {
      "order": "The Hero gets +2 hp"
    }
  },
  {
    "id": "deus_inf_spyashy_agent",
    "name_ru": "Спящий агент",
    "name_en": "Sleeper Agent",
    "faction": "deus",
    "type": "influence",
    "rarity": "special",
    "archetype": null,
    "exclusive_hero": "deus_nikosi",
    "atk": 3,
    "armor": 0,
    "hp": 4,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": 8,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Внедряется спящим на случайную линию врага. После активации бьёт первым: 3 урона Герою врага + по 2 двум случайным вражеским юнитам, затем возвращается к тебе"
    },
    "dsl_order": {
      "target": "self",
      "effect": "sleeper_agent_special",
      "duration": "permanent"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Знаешь только своего куратора. Только когда нужно — делаешь то, ради чего тебя внедрили.",
    "ability_text_en": {
      "order": "Infiltrates dormant onto a random enemy line. After activating, it strikes first: 3 damage to the enemy Hero + 2 to each of two random enemy units, then returns to you"
    }
  },
  {
    "id": "deus_inf_tyazhely_dron",
    "name_ru": "Тяжёлый дрон",
    "name_en": "Heavy Drone",
    "faction": "deus",
    "type": "influence",
    "rarity": "special",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 5,
    "armor": 3,
    "hp": 5,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": 6,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {},
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Сертифицированный для городских операций. Гарантия — 8 миссий. После 9-й — взрывается."
  },
  {
    "id": "deus_inf_znatok_iskinov",
    "name_ru": "Знаток искинов",
    "name_en": "AI Whisperer",
    "faction": "deus",
    "type": "influence",
    "rarity": "special",
    "archetype": null,
    "exclusive_hero": "deus_sina",
    "atk": 2,
    "armor": 2,
    "hp": 5,
    "keywords": [
      "stealth"
    ],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": 6,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "В начале каждого хода призывает Заражённого искином на свободную ячейку"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "turn_start",
      "filter": "any",
      "target": "self",
      "effect": "summon",
      "value": "deus_zarazheny_iskinom",
      "duration": "oneshot"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Знает шёпот ИИ. Слышит как искины переговариваются между импланами. Управляет ими словом — но никогда не оружием.",
    "ability_text_en": {
      "trigger": "At the start of each turn, summons an AI-Infected to a free slot"
    }
  },
  {
    "id": "deus_korp_finansist",
    "name_ru": "Корпоративный финансист",
    "name_en": "Corporate Financier",
    "faction": "deus",
    "type": "unit",
    "rarity": "epic",
    "archetype": null,
    "exclusive_hero": "deus_tanaki",
    "atk": 3,
    "armor": 2,
    "hp": 4,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 4,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "+5 Влияния"
    },
    "dsl_order": {
      "target": "self",
      "effect": "influence_gain",
      "value": "5",
      "duration": "oneshot"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Управляет 8 миллиардами в день. Зарабатывает в три раза больше за свой счёт.",
    "ability_text_en": {
      "order": "+5 Influence"
    }
  },
  {
    "id": "deus_korp_sdelka",
    "name_ru": "Корпоративная сделка",
    "name_en": "Corporate Deal",
    "faction": "deus",
    "type": "action",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "deus_tanaki",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Получи +3 Влияния. Призови Стажёра"
    },
    "dsl_order": {
      "target": "composite",
      "effect": "composite",
      "value": "influence_gain:3@self|summon:deus_stazher@own_line",
      "duration": "oneshot"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Подписи. Печати. Третий стажёр сегодня — и день только начался.",
    "ability_text_en": {
      "order": "Gain +3 Influence. Summon an Intern"
    }
  },
  {
    "id": "deus_korp_shantazhist",
    "name_ru": "Корпоративный шантажист",
    "name_en": "Corporate Blackmailer",
    "faction": "deus",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "deus_kirosa",
    "atk": 2,
    "armor": 0,
    "hp": 3,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "дай Молчание юниту врага на выбор"
    },
    "dsl_order": {
      "target": "enemy_choose",
      "effect": "silence",
      "duration": "permanent"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "У него есть фотографии. Ты не знаешь какие. Но ты хочешь чтобы он их забыл.",
    "ability_text_en": {
      "order": "Silence a chosen enemy unit"
    }
  },
  {
    "id": "deus_korpakula",
    "name_ru": "Корпоративная акула",
    "name_en": "Corporate Shark",
    "faction": "deus",
    "type": "unit",
    "rarity": "epic",
    "archetype": null,
    "exclusive_hero": "deus_sina",
    "atk": 3,
    "armor": 2,
    "hp": 5,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 4,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "При смерти союзного юнита получает +0/0/2"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "ally_died",
      "filter": "any",
      "target": "self",
      "effect": "buff_self_perm",
      "value": "0/0/2",
      "duration": "permanent"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "У неё нет ноздрей. Она чует кровь по структуре корпоративных бюджетов.",
    "ability_text_en": {
      "trigger": "When an allied unit dies, gets +0/0/2"
    }
  },
  {
    "id": "deus_korpdirector",
    "name_ru": "Корпоративный директор",
    "name_en": "Corporate Director",
    "faction": "deus",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 3,
    "armor": 2,
    "hp": 4,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "нанеси 1 урон всем вражеским юнитам на той же линии"
    },
    "dsl_order": {
      "target": "enemy_aoe_line",
      "effect": "damage",
      "value": "1",
      "duration": "oneshot"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Решения принимаются за 30 секунд. Последствия разгребают годами.",
    "ability_text_en": {
      "order": "Deal 1 damage to all enemy units on the same line"
    }
  },
  {
    "id": "deus_korpdiversant",
    "name_ru": "Корпоративный диверсант",
    "name_en": "Corporate Saboteur",
    "faction": "deus",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 2,
    "armor": 0,
    "hp": 3,
    "keywords": [
      "deathrattle_contract"
    ],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {},
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "У него три контракта на жизнь и четыре на смерть. Все четыре подписаны им самим."
  },
  {
    "id": "deus_korpoohranik",
    "name_ru": "Корпоративный охранник",
    "name_en": "Corporate Guard",
    "faction": "deus",
    "type": "unit",
    "rarity": "common",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 1,
    "armor": 2,
    "hp": 3,
    "keywords": [
      "taunt"
    ],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 1,
    "deck_limit": 3,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {},
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Костюм по уставу, шокер на поясе, чёрные очки даже в офисе."
  },
  {
    "id": "deus_korpreid",
    "name_ru": "Корпоративный рейд",
    "name_en": "Corporate Raid",
    "faction": "deus",
    "type": "action",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": null,
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Нанеси 4 урона выбранному вражескому юниту"
    },
    "dsl_order": {
      "target": "enemy_choose",
      "effect": "damage",
      "value": "4",
      "duration": "oneshot"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Юристы. Бухгалтеры. Сапёры. В таком порядке.",
    "ability_text_en": {
      "order": "Deal 4 damage to a chosen enemy unit"
    }
  },
  {
    "id": "deus_kurator_zachistok",
    "name_ru": "Куратор зачисток",
    "name_en": "Cleanup Curator",
    "faction": "deus",
    "type": "unit",
    "rarity": "epic",
    "archetype": null,
    "exclusive_hero": "deus_sina",
    "atk": 2,
    "armor": 0,
    "hp": 4,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 4,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "aura": "Пока этот юнит жив, при смерти союзного юнита наносит 1 урон Герою врага и случайный союзный юнит получает +0/1/1"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": {
      "filter": "while_alive",
      "target": "composite",
      "effect": "composite",
      "value": "damage:1@hero_enemy|buff_self_perm:0/1/1@ally_random_fallback_self",
      "condition": "on_ally_died"
    },
    "flavor_ru": "Не оставляет следов. Не оставляет свидетелей. Не оставляет совести.",
    "ability_text_en": {
      "aura": "While this unit is alive, when an allied unit dies it deals 1 damage to the enemy Hero and a random allied unit gets +0/1/1"
    }
  },
  {
    "id": "deus_lichnaya_gvardiya",
    "name_ru": "Личная гвардия",
    "name_en": "Personal Guard",
    "faction": "deus",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "deus_nikosi",
    "atk": 2,
    "armor": 2,
    "hp": 3,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "aura": "Пока этот юнит жив, Герой получает +1 атаки"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": {
      "filter": "while_alive",
      "target": "hero_self",
      "effect": "buff_stats",
      "value": "1/0/0"
    },
    "flavor_ru": "Сам не любил охрану, но потом перестал ходить без неё.",
    "ability_text_en": {
      "aura": "While this unit is alive, the Hero gets +1 attack"
    }
  },
  {
    "id": "deus_lichnoe_uchastie",
    "name_ru": "Личное участие",
    "name_en": "Personal Engagement",
    "faction": "deus",
    "type": "action",
    "rarity": "legendary",
    "archetype": null,
    "exclusive_hero": "deus_nikosi",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 5,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Нанеси выбранному персонажу урон = атаке твоего Героя. Игнорирует броню"
    },
    "dsl_order": {
      "target": "enemy_or_hero_choose",
      "effect": "special_damage_pierce_avangard",
      "value": "hero_atk",
      "duration": "oneshot"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Когда контракт нельзя поручить — приходится подписывать лично.",
    "ability_text_en": {
      "order": "Deal damage to a chosen character equal to your Hero's attack. Ignores armor"
    }
  },
  {
    "id": "deus_likvidatsiya_kontrakta",
    "name_ru": "Ликвидация контракта",
    "name_en": "Contract Liquidation",
    "faction": "deus",
    "type": "action",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "deus_sina",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Уничтожь своего юнита с атакой ≤ 2. Призови Заражённого искином и Стажёра на свою сторону"
    },
    "dsl_order": {
      "target": "composite",
      "effect": "composite",
      "value": "destroy:1@ally_choose_atk_le_2|summon:deus_zarazheny_iskinom@own_line|summon:deus_stazher@own_line",
      "duration": "oneshot",
      "condition": "ally_with_atk_le_2_exists"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Один уволен. Двое наняты. Эффективность отдела выросла на 100%.",
    "ability_text_en": {
      "order": "Destroy one of your units with attack ≤2. Summon an AI-Infected and an Intern to your side"
    }
  },
  {
    "id": "deus_lobbist",
    "name_ru": "Лоббист",
    "name_en": "Lobbyist",
    "faction": "deus",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "deus_tanaki",
    "atk": 2,
    "armor": 1,
    "hp": 4,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "В начале каждого хода +1 Влияния"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "turn_start",
      "filter": "any",
      "target": "self",
      "effect": "influence_gain",
      "value": "1",
      "duration": "oneshot"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Не пишет законов. Подсказывает кому что выпить и в каком порядке.",
    "ability_text_en": {
      "trigger": "At the start of each turn, +1 Influence"
    }
  },
  {
    "id": "deus_medik",
    "name_ru": "Корпоративный медик",
    "name_en": "Corporate Medic",
    "faction": "deus",
    "type": "unit",
    "rarity": "common",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 1,
    "armor": 0,
    "hp": 3,
    "keywords": [],
    "priority_override": "healer",
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 1,
    "deck_limit": 3,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "вылечи на 2 ХП союзника с самым маленьким ХП"
    },
    "dsl_order": {
      "target": "ally_lowest_hp",
      "effect": "heal",
      "value": "2",
      "duration": "oneshot"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Корпоративная страховка дорого стоит — но в полевых условиях помогают эти.",
    "ability_text_en": {
      "order": "Heal the ally with the lowest hp for 2 hp"
    }
  },
  {
    "id": "deus_medstrahovka",
    "name_ru": "Медицинская страховка",
    "name_en": "Medical Insurance",
    "faction": "deus",
    "type": "action",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": null,
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Вылечи своего Героя на 4 ХП"
    },
    "dsl_order": {
      "target": "hero_self",
      "effect": "heal",
      "value": "4",
      "duration": "oneshot"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Корпоративная страховка покрывает всё. Кроме разногласий с акционерами.",
    "ability_text_en": {
      "order": "Heal your Hero for 4 hp"
    }
  },
  {
    "id": "deus_mega_sdelka",
    "name_ru": "Мега-сделка",
    "name_en": "Mega Deal",
    "faction": "deus",
    "type": "action",
    "rarity": "epic",
    "archetype": null,
    "exclusive_hero": "deus_tanaki",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 4,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Призови Корпохранника на свою сторону. Следующие 3 призыва из стенда Влияния в этом матче стоят -50%"
    },
    "dsl_order": {
      "target": "composite",
      "effect": "composite",
      "value": "summon:deus_korpoohranik@own_line|next_n_summons_discount:3@50%",
      "duration": "oneshot"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "На таком уровне сделок охрана не охраняет. Она просто стоит там, где должна стоять.",
    "ability_text_en": {
      "order": "Summon a Corp Guard to your side. The next 3 summons from the Influence Stand this match cost -50%"
    }
  },
  {
    "id": "deus_menedzher",
    "name_ru": "Менеджер среднего звена",
    "name_en": "Mid-level Manager",
    "faction": "deus",
    "type": "unit",
    "rarity": "common",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 2,
    "armor": 1,
    "hp": 3,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 1,
    "deck_limit": 3,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {},
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Любит совещания и дешёвый кофе. Имплант в правом виске — для эффективности."
  },
  {
    "id": "deus_naemnik",
    "name_ru": "Наёмник",
    "name_en": "Mercenary",
    "faction": "deus",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "deus_kirosa",
    "atk": 3,
    "armor": 1,
    "hp": 3,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "верни врагу его юнита с атакой ≤ 2. Если рука врага полная (10 карт) — юнит уничтожается без сброса"
    },
    "dsl_order": {
      "target": "enemy_choose",
      "effect": "return_to_hand_enemy",
      "duration": "permanent",
      "condition": "target_atk_le_2"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "За правильные деньги уйдёт куда укажешь. И унесёт с собой того, кого попросишь.",
    "ability_text_en": {
      "order": "Return an enemy unit with attack ≤2 to the enemy's hand. If the enemy's hand is full (10 cards), the unit is destroyed instead of discarded"
    }
  },
  {
    "id": "deus_nalog_inspector",
    "name_ru": "Налоговый инспектор",
    "name_en": "Tax Inspector",
    "faction": "deus",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "deus_tanaki",
    "atk": 1,
    "armor": 0,
    "hp": 2,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "+2 Влияния"
    },
    "dsl_order": {
      "target": "self",
      "effect": "influence_gain",
      "value": "2",
      "duration": "oneshot"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Налоговый кодекс — это сборник способов получить от тебя то, что ты считал своим.",
    "ability_text_en": {
      "order": "+2 Influence"
    }
  },
  {
    "id": "deus_operativny_prikaz",
    "name_ru": "Оперативный приказ",
    "name_en": "Operative Order",
    "faction": "deus",
    "type": "action",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "deus_nikosi",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Герой получает Пробитие до конца следующего хода"
    },
    "dsl_order": {
      "target": "hero_self",
      "effect": "give_keyword",
      "keyword": "pierce",
      "duration": "until_end_of_next_turn"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Печать совета. Подпись директора. Защиты не существует.",
    "ability_text_en": {
      "order": "The Hero gains Pierce until the end of the next turn"
    }
  },
  {
    "id": "deus_peredovoy_shchit",
    "name_ru": "Передовой щит",
    "name_en": "Frontline Shield",
    "faction": "deus",
    "type": "action",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "deus_kirosa",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Герой получает Иммунитет"
    },
    "dsl_order": {
      "target": "hero_self",
      "effect": "give_keyword",
      "keyword": "immune",
      "duration": "1_turn"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Нанотехнологии стабилизируют поверхность кожи. Один удар. Один шанс.",
    "ability_text_en": {
      "order": "The Hero gains Immune"
    }
  },
  {
    "id": "deus_pereverbovka",
    "name_ru": "Перевербовка",
    "name_en": "Reconditioning",
    "faction": "deus",
    "type": "action",
    "rarity": "epic",
    "archetype": null,
    "exclusive_hero": "deus_kirosa",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 4,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Уничтожь одного своего юнита. Перемани вражеского юнита с атакой ≤ 5 на свою сторону"
    },
    "dsl_order": {
      "target": "composite",
      "effect": "composite",
      "value": "destroy:1@ally_choose|mind_control:atk_limit:5@enemy_choose",
      "duration": "permanent"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Один уйдёт. Другой придёт. Корпорация — это не люди, корпорация — это места.",
    "ability_text_en": {
      "order": "Destroy one of your units. Take control of an enemy unit with attack ≤5"
    }
  },
  {
    "id": "deus_podmazany_stukach",
    "name_ru": "Подмазанный стукач",
    "name_en": "Greased Snitch",
    "faction": "deus",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "deus_kirosa",
    "atk": 1,
    "armor": 0,
    "hp": 4,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "Накладывает Молчание на юнит, атаковавший его"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "unit_takes_damage",
      "filter": "self",
      "target": "attacker",
      "effect": "silence",
      "duration": "permanent"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Бьёшь его — он не отвечает. Просто записывает на голограмму твоё лицо.",
    "ability_text_en": {
      "trigger": "Silences any unit that attacks it"
    }
  },
  {
    "id": "deus_podpis_smertnika",
    "name_ru": "Подпись смертника",
    "name_en": "Death Signature",
    "faction": "deus",
    "type": "action",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "deus_sina",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Уничтожь одного своего юнита. Добери 2 карты"
    },
    "dsl_order": {
      "target": "composite",
      "effect": "composite",
      "value": "destroy:1@ally_choose|draw:2@self",
      "duration": "oneshot"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Подписывал сам. Знал что подписывает. Был не первый.",
    "ability_text_en": {
      "order": "Destroy one of your units. Draw 2 cards"
    }
  },
  {
    "id": "deus_predsedatel_tanaki",
    "name_ru": "Председатель Танаки",
    "name_en": "Chairman Tanaki",
    "faction": "deus",
    "type": "unit",
    "rarity": "legendary",
    "archetype": null,
    "exclusive_hero": "deus_tanaki",
    "atk": 5,
    "armor": 3,
    "hp": 7,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 5,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "удвой текущее количество очков Влияния (не выше максимума)"
    },
    "dsl_order": {
      "target": "self",
      "effect": "double_influence",
      "duration": "oneshot"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Председатель не приходит на собрания. Председатель — это собрание.",
    "ability_text_en": {
      "order": "Double your current Influence (not above the cap)"
    }
  },
  {
    "id": "deus_rasstrelnaya_komanda",
    "name_ru": "Расстрельная команда",
    "name_en": "Execution Squad",
    "faction": "deus",
    "type": "action",
    "rarity": "epic",
    "archetype": null,
    "exclusive_hero": "deus_nikosi",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 4,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Нанеси 6 урона выбранному персонажу"
    },
    "dsl_order": {
      "target": "enemy_or_hero_choose",
      "effect": "damage",
      "value": "6",
      "duration": "oneshot"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Шесть стволов. Шесть секунд. Шесть способов умереть.",
    "ability_text_en": {
      "order": "Deal 6 damage to a chosen character"
    }
  },
  {
    "id": "deus_reabilitatsiya",
    "name_ru": "Реабилитация",
    "name_en": "Rehabilitation",
    "faction": "deus",
    "type": "action",
    "rarity": "legendary",
    "archetype": null,
    "exclusive_hero": "deus_kirosa",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 5,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Полностью восстанови ХП своего Героя до максимума"
    },
    "dsl_order": {
      "target": "hero_self",
      "effect": "heal_to_full",
      "duration": "oneshot"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "У Деуса всегда есть план. И запасной план. И клиника на 27-м этаже.",
    "ability_text_en": {
      "order": "Fully restore your Hero's hp to maximum"
    }
  },
  {
    "id": "deus_restrukturizatsiya",
    "name_ru": "Реструктуризация",
    "name_en": "Restructuring",
    "faction": "deus",
    "type": "action",
    "rarity": "common",
    "archetype": null,
    "exclusive_hero": null,
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 1,
    "deck_limit": 3,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Дай выбранному юниту +0/1/1"
    },
    "dsl_order": {
      "target": "ally_choose",
      "effect": "buff_stats",
      "value": "0/1/1",
      "duration": "permanent"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Сегодня ты курьер. Завтра — отдел. Послезавтра — корпорация.",
    "ability_text_en": {
      "order": "Give a chosen unit +0/1/1"
    }
  },
  {
    "id": "deus_shpion",
    "name_ru": "Корпоративный шпион",
    "name_en": "Corporate Spy",
    "faction": "deus",
    "type": "unit",
    "rarity": "common",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 2,
    "armor": 0,
    "hp": 2,
    "keywords": [
      "stealth"
    ],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 1,
    "deck_limit": 3,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {},
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Появляется в коридорах серверной, исчезает раньше чем включится охрана."
  },
  {
    "id": "deus_sliyanie",
    "name_ru": "Корпоративное слияние",
    "name_en": "Corporate Merger",
    "faction": "deus",
    "type": "action",
    "rarity": "common",
    "archetype": null,
    "exclusive_hero": null,
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 1,
    "deck_limit": 3,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Добери 2 карты. Нанеси 1 урон своему Герою"
    },
    "dsl_order": {
      "target": "composite",
      "effect": "composite",
      "value": "draw:2@self|damage:1@hero_self",
      "duration": "oneshot"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Объединение никогда не бывает мирным.",
    "ability_text_en": {
      "order": "Draw 2 cards. Deal 1 damage to your Hero"
    }
  },
  {
    "id": "deus_snayper_razvedchik",
    "name_ru": "Снайпер-разведчик",
    "name_en": "Sniper-Recon",
    "faction": "deus",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "deus_nikosi",
    "atk": 2,
    "armor": 0,
    "hp": 2,
    "keywords": [
      "stealth"
    ],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "+2 Влияния при каждой атаке"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "unit_attack",
      "filter": "self",
      "target": "self",
      "effect": "influence_gain",
      "value": "2",
      "duration": "oneshot"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Цель — двух километров. Время реакции — две секунды. Промахов — ноль.",
    "ability_text_en": {
      "trigger": "+2 Influence on each attack"
    }
  },
  {
    "id": "deus_sovet_directorov",
    "name_ru": "Совет директоров",
    "name_en": "Board of Directors",
    "faction": "deus",
    "type": "unit",
    "rarity": "epic",
    "archetype": null,
    "exclusive_hero": "deus_tanaki",
    "atk": 4,
    "armor": 2,
    "hp": 4,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 4,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "aura": "Пока этот юнит жив, в начале каждого хода +2 Влияния"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": {
      "filter": "while_alive",
      "target": "self",
      "effect": "influence_gain",
      "value": "2",
      "condition": "turn_start"
    },
    "flavor_ru": "Семеро мужчин в одной комнате решают за всю планету. Иногда даже трезвые.",
    "ability_text_en": {
      "aura": "While this unit is alive, +2 Influence at the start of each turn"
    }
  },
  {
    "id": "deus_specagent",
    "name_ru": "Спецагент",
    "name_en": "Special Agent",
    "faction": "deus",
    "type": "unit",
    "rarity": "common",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 2,
    "armor": 0,
    "hp": 2,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 1,
    "deck_limit": 3,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "deathrattle": "+1 Влияния"
    },
    "dsl_order": null,
    "dsl_deathrattle": {
      "target": "self",
      "effect": "influence_gain",
      "value": "1",
      "duration": "oneshot"
    },
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Контракт на 5 лет, с правом на одну успешную миссию посмертно.",
    "ability_text_en": {
      "deathrattle": "+1 Influence"
    }
  },
  {
    "id": "deus_specnaz",
    "name_ru": "Спецназ Деуса",
    "name_en": "Deus Spec-Ops",
    "faction": "deus",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 3,
    "armor": 2,
    "hp": 3,
    "keywords": [
      "pierce"
    ],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {},
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Бьют по точкам опоры. Бронежилеты — это просто звуки в их пробиваниях."
  },
  {
    "id": "deus_starshiy_shpion",
    "name_ru": "Старший шпион",
    "name_en": "Senior Spy",
    "faction": "deus",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 4,
    "armor": 0,
    "hp": 3,
    "keywords": [
      "stealth"
    ],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {},
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Прошёл три ликвидации, четыре повышения и пять смен личности. Никто не помнит его настоящего имени."
  },
  {
    "id": "deus_stazher",
    "name_ru": "Стажёр",
    "name_en": "Trainee",
    "faction": "deus",
    "type": "unit",
    "rarity": "common",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 1,
    "armor": 0,
    "hp": 2,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 1,
    "deck_limit": 3,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {},
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Молодой клерк-наёмник, готовый умереть за квартальную премию."
  },
  {
    "id": "deus_takticheskiy_shturm",
    "name_ru": "Тактический штурм",
    "name_en": "Tactical Assault",
    "faction": "deus",
    "type": "action",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "deus_nikosi",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Герой получает +2 атаки до конца следующего хода"
    },
    "dsl_order": {
      "target": "hero_self",
      "effect": "buff_stats",
      "value": "2/0/0",
      "duration": "until_end_of_next_turn"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Возьмите ствол. У вас есть 30 секунд на принятие решения.»",
    "ability_text_en": {
      "order": "The Hero gets +2 attack until the end of the next turn"
    }
  },
  {
    "id": "deus_tayny_sovet",
    "name_ru": "Тайный совет",
    "name_en": "Secret Council",
    "faction": "deus",
    "type": "action",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "deus_tanaki",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Увеличь свой максимум Влияния на +2 до конца матча (с 10 до 12)"
    },
    "dsl_order": {
      "target": "self",
      "effect": "influence_max_increase",
      "value": "2",
      "duration": "permanent"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Не все решения принимаются на совете. Главные — за бутылкой коньяка после.",
    "ability_text_en": {
      "order": "Increase your Influence cap by +2 for the rest of the match (from 10 to 12)"
    }
  },
  {
    "id": "deus_temnaya_vdova_sina",
    "name_ru": "Тёмная вдова Сина",
    "name_en": "Dark Widow Sina",
    "faction": "deus",
    "type": "unit",
    "rarity": "legendary",
    "archetype": null,
    "exclusive_hero": "deus_sina",
    "atk": 2,
    "armor": 3,
    "hp": 8,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 5,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "При смерти союзного юнита получает +1/0/1  и даёт +1 Влияния"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "ally_died",
      "filter": "any",
      "target": "composite",
      "effect": "composite",
      "value": "buff_self_perm:1/0/1@self|influence_gain:1@hero_self",
      "duration": "permanent"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Похоронила всех мужей. Похоронила всех конкурентов. Похоронит и себя — но не сегодня.",
    "ability_text_en": {
      "trigger": "When an allied unit dies, gets +1/0/1 and gives +1 Influence"
    }
  },
  {
    "id": "deus_ukaz_soveta",
    "name_ru": "Указ совета директоров",
    "name_en": "Board Decree",
    "faction": "deus",
    "type": "action",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": null,
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Наложи Молчание на выбранного вражеского юнита"
    },
    "dsl_order": {
      "target": "enemy_choose",
      "effect": "silence",
      "duration": "permanent"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Подпись 7 директоров. Печать корпорации. Цена твоему голосу.",
    "ability_text_en": {
      "order": "Silence a chosen enemy unit"
    }
  },
  {
    "id": "deus_vedomost_poter",
    "name_ru": "Ведомость потерь",
    "name_en": "Casualty Ledger",
    "faction": "deus",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "deus_sina",
    "atk": 1,
    "armor": 1,
    "hp": 4,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "Со смертью каждого союзного юнита получает +0/1/0 и добор 1 карты"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "ally_died",
      "filter": "any",
      "target": "composite",
      "effect": "composite",
      "value": "draw:1@self|buff_self_perm:0/1/0@self",
      "duration": "permanent"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "В корпорации каждая жизнь — строчка. Каждая смерть — две строчки.",
    "ability_text_en": {
      "trigger": "When each allied unit dies, gets +0/1/0 and draws 1 card"
    }
  },
  {
    "id": "deus_velikaya_zhertva",
    "name_ru": "Великая жертва",
    "name_en": "Great Sacrifice",
    "faction": "deus",
    "type": "action",
    "rarity": "legendary",
    "archetype": null,
    "exclusive_hero": "deus_sina",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 5,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Выбери до 3 своих юнитов с атакой 2+. Уничтожь их. За каждого получи +3 Влияния и нанеси 3 урона Герою врага"
    },
    "dsl_order": {
      "target": "ally_choose_multiple",
      "effect": "mass_sacrifice",
      "value": "max_count:3|atk_filter:2|per_unit:influence_gain:3+damage:3@hero_enemy_pierce_avangard",
      "duration": "oneshot"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Корпорация — это люди. И самые ценные люди — это те, кто готов перестать ими быть.»",
    "ability_text_en": {
      "order": "Choose up to 3 of your units with attack 2+. Destroy them. For each one, gain +3 Influence and deal 3 damage to the enemy Hero"
    }
  },
  {
    "id": "deus_vrazhdebnoe_pogloshchenie",
    "name_ru": "Враждебное поглощение",
    "name_en": "Hostile Takeover",
    "faction": "deus",
    "type": "action",
    "rarity": "legendary",
    "archetype": null,
    "exclusive_hero": "deus_kirosa",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 5,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Перемани до 3 вражеских юнитов с атакой ≤ 3"
    },
    "dsl_order": {
      "target": "enemy_choose",
      "effect": "mind_control_mass",
      "value": "atk_limit:3|count:3",
      "duration": "permanent"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Сегодня ты их акционер. Завтра — их работодатель. Послезавтра — забудешь их имена.",
    "ability_text_en": {
      "order": "Take control of up to 3 enemy units with attack ≤3"
    }
  },
  {
    "id": "deus_vygovor",
    "name_ru": "Выговор",
    "name_en": "Reprimand",
    "faction": "deus",
    "type": "action",
    "rarity": "common",
    "archetype": null,
    "exclusive_hero": null,
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 1,
    "deck_limit": 3,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Нанеси 2 урона выбранному вражескому юниту. Призови Стажёра на свою сторону"
    },
    "dsl_order": {
      "target": "composite",
      "effect": "composite",
      "value": "damage:2@enemy_choose|summon:deus_stazher@own_line",
      "duration": "oneshot"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "На каждое увольнение находится новый стажёр. Корпорация не останавливается.",
    "ability_text_en": {
      "order": "Deal 2 damage to a chosen enemy unit. Summon an Intern to your side"
    }
  },
  {
    "id": "deus_zahvat_kontrakta",
    "name_ru": "Захват контракта",
    "name_en": "Contract Takeover",
    "faction": "deus",
    "type": "action",
    "rarity": "epic",
    "archetype": null,
    "exclusive_hero": "deus_kirosa",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 4,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Перемани вражеского юнита на 3 хода"
    },
    "dsl_order": {
      "target": "enemy_choose",
      "effect": "mind_control_temporary",
      "value": "atk_limit:any|duration:3_turns",
      "duration": "permanent"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Контракт на 3 фазы Луны. Подписан. Рассчитан. Возврат нерасторжим.»",
    "ability_text_en": {
      "order": "Take control of an enemy unit for 3 turns"
    }
  },
  {
    "id": "deus_zahvat_rynka",
    "name_ru": "Захват рынка",
    "name_en": "Market Takeover",
    "faction": "deus",
    "type": "action",
    "rarity": "legendary",
    "archetype": null,
    "exclusive_hero": "deus_tanaki",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 5,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Сыграй 2 случайные карты Влияния из стенда бесплатно"
    },
    "dsl_order": {
      "target": "self",
      "effect": "free_summon_from_influence_pool",
      "value": "2",
      "duration": "oneshot"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Не покупка. Не слияние. Просто решение.",
    "ability_text_en": {
      "order": "Play 2 random Influence cards from the Stand for free"
    }
  },
  {
    "id": "deus_zarazheny_iskinom",
    "name_ru": "Заражённый искином",
    "name_en": "AI-Infected",
    "faction": "deus",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "deus_sina",
    "atk": 2,
    "armor": 0,
    "hp": 2,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": 3,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "призови ещё одного Заражённого искином",
      "deathrattle": "1 урон случайному персонажу врага"
    },
    "dsl_order": {
      "target": "self",
      "effect": "summon",
      "value": "deus_zarazheny_iskinom",
      "duration": "oneshot"
    },
    "dsl_deathrattle": {
      "target": "enemy_random_or_hero",
      "effect": "damage",
      "value": "1",
      "duration": "oneshot"
    },
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "Был стажёром. Был программистом. Был мужем. Теперь он только переносчик.",
    "ability_text_en": {
      "order": "Summon another AI-Infected",
      "deathrattle": "1 damage to a random enemy character"
    }
  }
];
